<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.BrandCampaignEditPage {
    textarea {
        min-height: 100px;
    }

    h4 {
        margin: 40px 0 20px 0;
    }
}
</style>

<script type="text/babel">
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [RestoreOnPageBack],
    props: ['dataCampaign'],

    data() {
        const wantedPostsTypes = this.parseWantedPostsTypes(this.dataCampaign)

        const descFields = this.parseDescriptionFields(this.dataCampaign.description || '')

        return {
            campaign: this.dataCampaign,
            form: new SparkForm({
                ...this.dataCampaign,
                ...{ wanted_posts_types: wantedPostsTypes },
                desc_about_brand: descFields.desc_about_brand,
                desc_sdg: descFields.desc_sdg,
                desc_about_campaign: descFields.desc_about_campaign,
                desc_your_task: descFields.desc_your_task,
                desc_practical_info: descFields.desc_practical_info,
            }),
            platformPostTypes: this.getPlatformPostTypes(),
        }
    },

    computed: {},

    created() {
        if (this.form.budget_amount === null) {
            this.form.budget_amount = 2000
        }

        if (this.form.platform.reach_min !== null && this.form.reach_required === null) {
            this.form.reach_required = this.form.platform.reach_min
        }
    },

    methods: {
        parseDescriptionFields(description) {
            const fields = {
                desc_about_brand: '',
                desc_sdg: '',
                desc_about_campaign: '',
                desc_your_task: '',
                desc_practical_info: '',
            }

            if (!description) return fields

            const headers = [
                { pattern: /^Om brandet:/m, key: 'desc_about_brand' },
                { pattern: /^FN's verdensmål:/m, key: 'desc_sdg' },
                { pattern: /^Om kampagnen:/m, key: 'desc_about_campaign' },
                { pattern: /^Din opgave:/m, key: 'desc_your_task' },
                { pattern: /^Praktisk information:/m, key: 'desc_practical_info' },
            ]

            // Find all header positions
            const matches = headers
                .map(h => {
                    const match = description.match(h.pattern)
                    return match
                        ? { key: h.key, start: match.index, headerLen: match[0].length }
                        : null
                })
                .filter(Boolean)
                .sort((a, b) => a.start - b.start)

            // Extract content between headers
            for (let i = 0; i < matches.length; i++) {
                const contentStart = matches[i].start + matches[i].headerLen
                const contentEnd =
                    i + 1 < matches.length ? matches[i + 1].start : description.length
                fields[matches[i].key] = description.substring(contentStart, contentEnd).trim()
            }

            return fields
        },
        mergeDescriptionFields() {
            const sections = [
                { header: 'Om brandet:', value: this.form.desc_about_brand || '' },
                { header: "FN's verdensmål:", value: this.form.desc_sdg || '' },
                { header: 'Om kampagnen:', value: this.form.desc_about_campaign || '' },
                { header: 'Din opgave:', value: this.form.desc_your_task || '' },
                { header: 'Praktisk information:', value: this.form.desc_practical_info || '' },
            ]

            return sections.map(s => `${s.header} ${s.value.trim()}`).join('\n')
        },
        parseWantedPostsTypes(dataCampaign) {
            // Define default post types with initial values set to 0
            const defaultTypes = {
                posts: 0,
                stories: 0,
                reels: 0,
                videos: 0,
                shorts: 0,
                sponsored: 0,
                live: 0,
                blog: 0,
            }

            // If wanted_posts_types exists in dataCampaign, parse and assign values
            if (dataCampaign.wanted_posts_types) {
                Object.keys(defaultTypes).forEach(key => {
                    // Check if the key exists in dataCampaign.wanted_posts_types and has a value property
                    if (
                        dataCampaign.wanted_posts_types[key] &&
                        dataCampaign.wanted_posts_types[key].hasOwnProperty('value')
                    ) {
                        defaultTypes[key] =
                            parseInt(dataCampaign.wanted_posts_types[key]['value'], 10) || 0
                    }
                })
            }

            // Return the appropriate post types based on the platform slug
            switch (dataCampaign.platform.slug) {
                case 'analytics':
                    return {
                        blog: {
                            title: 'Blog Post',
                            value: defaultTypes.blog,
                        },
                    }

                case 'instagram_business':
                    return {
                        posts: {
                            title: 'Post',
                            value: defaultTypes.posts,
                        },
                        stories: {
                            title: 'Story',
                            value: defaultTypes.stories,
                        },
                        reels: {
                            title: 'Reels',
                            value: defaultTypes.reels,
                        },
                        live: {
                            title: 'Live',
                            value: defaultTypes.live,
                        },
                    }

                case 'youtube':
                    return {
                        videos: {
                            title: 'Video',
                            value: defaultTypes.videos,
                        },
                        shorts: {
                            title: 'Short',
                            value: defaultTypes.shorts,
                        },
                        sponsored: {
                            title: 'Sponsor Video',
                            value: defaultTypes.sponsored,
                        },
                        live: {
                            title: 'Live',
                            value: defaultTypes.live,
                        },
                    }
                default:
                    return {}
            }
        },

        getPlatformPostTypes() {
            switch (this.dataCampaign.platform.slug) {
                case 'analytics':
                    return [
                        {
                            id: 'blog',
                            name: 'sponsoreret indlæg',
                        },
                    ]

                case 'instagram_business':
                    return [
                        {
                            id: 'posts',
                            name: 'posts',
                        },
                        {
                            id: 'stories',
                            name: 'stories',
                        },
                        {
                            id: 'reels',
                            name: 'reels',
                        },
                        {
                            id: 'live',
                            name: 'live',
                        },
                    ]

                case 'youtube':
                    return [
                        {
                            id: 'videos',
                            name: 'videoer',
                        },
                        {
                            id: 'shorts',
                            name: 'shorts',
                        },
                        {
                            id: 'sponsored',
                            name: 'sponsoreret post (videoer med kort reklame indslag)',
                        },
                        {
                            id: 'live',
                            name: 'live',
                        },
                    ]

                default:
                    return []
            }
        },
        updateWantedPostAmount() {
            let amount = this.form.wanted_posts
            this.platformPostTypes.forEach(item => {
                amount -= this.form.wanted_posts_types[item.id]
                if (amount < 0) {
                    this.form.wanted_posts_types[item.id] += amount
                }
            })
        },
        updateWantedPostTypes(id) {
            let amount = this.form.wanted_posts
            amount -= this.form.wanted_posts_types[id]

            this.platformPostTypes.forEach(item => {
                if (item.id !== id) {
                    amount -= this.form.wanted_posts_types[item.id]
                    if (amount < 0) {
                        this.form.wanted_posts_types[item.id] += amount
                    }
                }
            })
        },
        validateDescriptionFields() {
            const requiredDescFields = [
                { key: 'desc_about_brand', label: 'Om brandet' },
                { key: 'desc_sdg', label: "FN's verdensmål" },
                { key: 'desc_about_campaign', label: 'Om kampagnen' },
                { key: 'desc_your_task', label: 'Din opgave' },
                { key: 'desc_practical_info', label: 'Praktisk information' },
            ]

            const errors = {}
            requiredDescFields.forEach(f => {
                if (!this.form[f.key] || !this.form[f.key].trim()) {
                    errors[f.key] = [`${f.label} er påkrævet.`]
                }
            })

            if (Object.keys(errors).length > 0) {
                this.form.setErrors(errors)
                return false
            }

            return true
        },
        update() {
            if (!this.validateDescriptionFields()) {
                return
            }

            this.form.errors.forget()

            this.form.description = this.mergeDescriptionFields()

            let interests = []
            $('.interests-wrapper input:checked').each(function() {
                interests.push(
                    $(this)
                        .attr('name')
                        .substring('form.interests'.length + 1)
                        .slice(0, -1)
                )
            })

            this.form.interests = interests

            this.form.expires_at = $('input[name="expires_at"]').val()
            Spark.sendFormData('put', route('api.campaign.update', this.form.id), this.form).then(
                response => {
                    this.campaign = response.data

                    NavigationProvider.go(`/campaigns/${response.data.id}`)
                }
            )
        },
    },
}
</script>
